// Path: src/components/aols/aeo/OLSupdates/OLSupdates.tsx
// Updated to import and route to the new OLS2965 Live Help Desk announcement.

import React, { useRef, useState, useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import styled from "styled-components";
import { Layout, Button, Typography, Breadcrumb } from "antd";
import { Helmet } from "react-helmet-async";
import { HomeOutlined } from "@ant-design/icons";
import logo from "/logo.jpg";
import { Update, updates1000 } from "./OLS1000/OLS1000";
import { updates1500 } from "./OLS1500/OLS1500";
import { updates2100 } from "./OLS2100/OLS2100";
import { updates2700 } from "./OLS2700/OLS2700";
import { updates2800 } from "./OLS2800/OLS2800";
import { updates2900 } from "./OLS2900/OLS2900";
import OLS2900 from "./OLS2900/OLS2900";
import OLS2903 from "./OLS2900/OLS2903";
import OLS2904 from "./OLS2900/OLS2904";
import OLS2905 from "./OLS2900/OLS2905";
import OLS2908 from "./OLS2900/OLS2908";
import OLS2909 from "./OLS2900/OLS2909";
import OLS2910 from "./OLS2900/OLS2910";
import OLS2911 from "./OLS2900/OLS2911";
import OLS2912 from "./OLS2900/OLS2912";
import OLS2913 from "./OLS2900/OLS2913";
import OLS2914 from "./OLS2900/OLS2914";
import OLS2915 from "./OLS2900/OLS2915";
import OLS2916 from "./OLS2900/OLS2916";
import OLS2917 from "./OLS2900/OLS2917";
import OLS2918 from "./OLS2900/OLS2918";
import OLS2919 from "./OLS2900/OLS2919";
import OLS2920 from "./OLS2900/OLS2920";
import OLS2921 from "./OLS2900/OLS2921";
import OLS2922 from "./OLS2900/OLS2922";
import OLSLM2922 from "./OLS2900/OLSLM2922";
import OLSLM2923 from "./OLS2900/OLSLM2923";
import OLSLM2924 from "./OLS2900/OLSLM2924";
import OLS2945 from "./OLS2900/OLS2945";
import OLS2953 from "./OLS2900/OLS2953";
import OLS2965 from "./OLS2900/OLS2965";
import OLS2966 from "./OLS2900/OLS2966";
import OLS2967 from "./OLS2900/OLS2967"; // Added import for OLS2967
import OLSupdatesUp from "./OLSupdatesUp";
import { useFirebase } from "../../../dev/Firebase/Firebase";

const { Title, Paragraph } = Typography;

const FullHeightLayout = styled(Layout)`
  min-height: 100vh;
  background: #000000;
`;

const ContentSection = styled.section`
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
  background: #000000;
  color: #fff;
  position: relative;
`;

const Logo = styled.img`
  max-width: 200px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(255, 204, 0, 0.3);
  transition: transform 0.3s ease;
`;

const UpdateList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0;
`;

const UpdateItem = styled.li`
  margin-bottom: 10px;
  color: #fff;
  line-height: 1.6;

  a {
    color: #ffaa00;
    text-decoration: none;
    padding: 5px 10px;
    display: block;
    border: 1px solid #ffaa00;
    border-radius: 4px;
    transition: background 0.3s, color 0.3s;

    &:hover {
      background: #ffaa00;
      color: #000;
    }

    &:focus {
      outline: 2px solid #40c4ff;
      outline-offset: 2px;
    }
  }
`;

const CustomButton = styled(Button)`
  margin: 5px;
  background-color: #1890ff;
  border-color: #1890ff;
  color: white;

  &:hover,
  &:focus {
    background-color: #40a9ff;
    border-color: #40a9ff;
    color: white;
  }

  a {
    color: white;
    text-decoration: none;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

const NavButton = styled(Button)`
  margin: 5px;
  background-color: #ffaa00;
  border-color: #ffaa00;
  color: black;

  &:hover,
  &:focus {
    background-color: #ffc107;
    border-color: #ffc107;
    color: black;
  }

  a {
    color: black;
    text-decoration: none;
  }
`;

const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1001;

  .ant-breadcrumb a {
    color: #ffcc00;
    transition: color 0.3s ease;
  }

  .ant-breadcrumb a:hover {
    color: #ffaa00;
  }

  @media (max-width: 768px) {
    left: 10px;
    top: 5px;
    .ant-breadcrumb {
      font-size: 12px;
    }
  }
`;

const ToggleHeader = styled.div`
  background: #1a1a1a;
  color: #ffffff;
  font-weight: 700;
  font-size: 24px;
  padding: 16px 20px;
  text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.2);
  border: 1px solid #ffaa00;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;

  &:hover {
    background: #2a2a2a;
  }
`;

const ToggleContent = styled.div`
  background: #1a1a1a;
  color: #ffffff;
  border: 1px solid #ffaa00;
  border-radius: 8px;
  padding: 16px;
  margin-top: 10px;
`;

const ToggleButton = styled.button`
  background-color: transparent;
  border: 1px solid #ffaa00;
  color: #ffaa00;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover,
  &:focus {
    background-color: #ffaa00;
    color: black;
  }
`;

const OLSupdates: React.FC = () => {
  const { logEvent } = useFirebase();
  const milestones: { key: string; header: string; updates: Update[] }[] = [
    { key: "2800", header: "OLS 2800", updates: updates2800 },
    { key: "2700", header: "OLS 2700", updates: updates2700 },
    { key: "2100", header: "OLS 2100", updates: updates2100 },
    { key: "1500", header: "OLS 1500", updates: updates1500 },
    { key: "1000", header: "OLS 1000", updates: updates1000 },
  ];

  const milestoneRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>(
    milestones.reduce((acc, milestone) => {
      acc[milestone.key] = false;
      return acc;
    }, {} as { [key: string]: boolean })
  );

  useEffect(() => {
    logEvent("page_view", { page_path: "/olsupdates" });
  }, [logEvent]);

  const scrollToMilestone = (key: string) => {
    const element = milestoneRefs.current[key];
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const toggleSection = (key: string) => {
    setExpandedSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "OneLightSystem OLS",
      alternateName: "OLS Aunselo",
      url: "https://www.olsme.com",
      logo: "https://www.olsme.com/logo.jpg",
      description: "OneLightSystem OLS provides updates on meditation education, spiritual growth, and asset announcements through Sun Light Meditation programs, including OLSLM 2924, OLSLM 2923, the OLS Calendar Widget, and Light Time Clock Widget.",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Belmont",
        addressRegion: "CA",
        addressCountry: "US",
      },
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "contact@olsme.com",
      },
      sameAs: [
        "https://www.linkedin.com/company/onelightsystem",
        "https://twitter.com/onelightsystem",
        "https://www.facebook.com/onelightsystem",
        "https://www.instagram.com/onelightsystem",
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.olsme.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "OLS Updates",
          item: "https://www.olsme.com/olsupdates",
        },
      ],
    },
  ];

  return (
    <FullHeightLayout className="full-height-layout">
      <Helmet>
        <title>OLS Updates | OneLightSystem - Meditation & Asset Announcements</title>
        <meta
          name="description"
          content="Stay updated with OneLightSystem (OLS) official announcements on olsme.com. Explore the latest on OLS iee.aeo, Sun Light Meditation, OLSLM assets including OLSLM 2924, OLSLM 2923, OLS Calendar Widget, Light Time Clock Widget, and meditation education events."
        />
        <meta
          name="keywords"
          content="OLS Updates, OneLightSystem, OLS iee.aeo, Sun Light Meditation, Light Science, OLSLM assets, meditation education, spiritual growth, meditation events, asset announcements, OLS Calendar Widget, Light Time Clock Widget, correct calendar, OLSLM 2924, OLSLM 2923"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="OneLightSystem OLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:title" content="OLS Updates | OneLightSystem - Meditation & Asset Announcements" />
        <meta
          property="og:description"
          content="Stay updated with OneLightSystem (OLS) official announcements on olsme.com. Explore the latest on OLS iee.aeo, Sun Light Meditation, OLSLM assets including OLSLM 2924, OLSLM 2923, OLS Calendar Widget, Light Time Clock Widget, and meditation education events."
        />
        <meta property="og:url" content="https://www.olsme.com/olsupdates" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.olsme.com/logo.jpg" />
        <meta property="og:image:alt" content="OneLightSystem OLS Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="OneLightSystem OLS" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onelightsystem" />
        <meta name="twitter:title" content="OLS Updates | OneLightSystem - Meditation & Asset Announcements" />
        <meta
          name="twitter:description"
          content="Stay updated with OneLightSystem (OLS) official announcements on olsme.com. Explore the latest on OLS iee.aeo, Sun Light Meditation, OLSLM assets including OLSLM 2924, OLSLM 2923, OLS Calendar Widget, Light Time Clock Widget, and meditation education events."
        />
        <meta name="twitter:image" content="https://www.olsme.com/logo.jpg" />
        <meta name="twitter:image:alt" content="OneLightSystem OLS Logo" />
        <link rel="canonical" href="https://www.olsme.com/olsupdates" />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <Routes>
        <Route
          path=""
          element={
            <>
              <BreadcrumbWrapper>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to="/">
                      <HomeOutlined /> Home
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>OLS Updates</Breadcrumb.Item>
                </Breadcrumb>
              </BreadcrumbWrapper>
              <ContentSection className="content-section">
                <div className="content">
                  <a href="https://www.olsme.com" aria-label="OneLightSystem Home">
                    <Logo src={logo} alt="OneLightSystem OLS Logo" className="logo" />
                  </a>

                  <Title level={1} className="section-title">
                    OneLightSystem OLS Updates
                  </Title>
                  <Paragraph className="content-text">
                    Welcome to the new home of OLS updates! As of April 2025, we’re transitioning from Blogger to olsme.com for a more direct, first-hand experience.
                    Stay tuned for the latest on OLS iee.aeo, meditation education, and asset announcements.
                  </Paragraph>
                  <ButtonRow>
                    <NavButton>
                      <Link to="/OLSaeo">OLS iee.aeo</Link>
                    </NavButton>
                    <NavButton>
                      <Link to="/Privacy">OLS privacy</Link>
                    </NavButton>
                    <NavButton>
                      <Link to="/Stat">OLS student</Link>
                    </NavButton>
                    <NavButton>
                      <Link to="/aOLSLMasset">OLSLM asset</Link>
                    </NavButton>
                    <NavButton>
                      <Link to="/olsupdates/upcoming">Upcoming Updates</Link>
                    </NavButton>
                  </ButtonRow>

                  <div className="feature-card">
                    <UpdateList className="update-list">
                      {updates2900.map((update) => (
                        <UpdateItem className="update-item" key={update.id}>
                          <Link to={`/olsupdates/ols2900/${update.id}`} aria-label={`View update ${update.text}`}>
                            {update.id}. {update.text}
                          </Link>
                        </UpdateItem>
                      ))}
                    </UpdateList>

                    <div className="quick-nav-buttons">
                      {milestones.map((milestone) => (
                        <NavButton
                          key={milestone.key}
                          className="quick-nav-button"
                          onClick={() => scrollToMilestone(milestone.key)}
                        >
                          {milestone.header}
                        </NavButton>
                      ))}
                    </div>

                    {milestones.map((milestone) => (
                      <div
                        className="milestone-box"
                        key={milestone.key}
                        ref={(el) => (milestoneRefs.current[milestone.key] = el)}
                      >
                        <ToggleHeader onClick={() => toggleSection(milestone.key)}>
                          <span>{milestone.header}</span>
                          <span>{expandedSections[milestone.key] ? "▲" : "▼"}</span>
                        </ToggleHeader>
                        {expandedSections[milestone.key] && (
                          <ToggleContent>
                            <ul className="update-list">
                              {milestone.updates.map((update) => (
                                <UpdateItem className="update-item" key={update.id}>
                                  {update.link ? (
                                    <a href={update.link} target="_blank" rel="noopener noreferrer" aria-label={`View update ${update.text}`}>
                                      {update.id}. {update.text}
                                    </a>
                                  ) : (
                                    <span>{update.id}. {update.text}</span>
                                  )}
                                </UpdateItem>
                              ))}
                            </ul>
                            <div className="collapse-bottom-wrapper">
                              <ToggleButton onClick={() => toggleSection(milestone.key)}>
                                Collapse
                              </ToggleButton>
                            </div>
                          </ToggleContent>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="social-follow-wrapper">
                    <a href="https://github.com/sponsors/onelightsystem" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                      <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/github.svg" alt="GitHub" />
                    </a>
                    <a href="https://www.blogger.com/profile/0939345987613456973" target="_blank" rel="noopener" aria-label="Blogger">
                      <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/blogger.svg" alt="Blogger" />
                    </a>
                    <a href="https://www.facebook.com/onelightsystemols" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                      <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/facebook.svg" alt="Facebook" />
                    </a>
                    <a href="https://www.linkedin.com/company/one-light-system" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                      <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/linkedin.svg" alt="LinkedIn" />
                    </a>
                    <a href="https://www.youtube.com/@ONELIGHTSYSTEMOLSMeditation" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                      <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/youtube.svg" alt="YouTube" />
                    </a>
                    <a href="https://x.com/onelightsystem" target="_blank" rel="noopener noreferrer" aria-label="X Twitter">
                      <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/x.svg" alt="X" />
                    </a>
                  </div>

                  <div className="button-group">
                    <CustomButton className="custom-button">
                      <Link to="/contact">Contact OneLightSystem OLS</Link>
                    </CustomButton>
                  </div>
                </div>
              </ContentSection>
            </>
          }
        />
        <Route path="ols2900" element={<OLS2900 />} />
        <Route path="ols2900/2903" element={<OLS2903 />} />
        <Route path="ols2900/2904" element={<OLS2904 />} />
        <Route path="ols2900/2905" element={<OLS2905 />} />
        <Route path="ols2900/2908" element={<OLS2908 />} />
        <Route path="ols2900/2909" element={<OLS2909 />} />
        <Route path="ols2900/2910" element={<OLS2910 />} />
        <Route path="ols2900/2911" element={<OLS2911 />} />
        <Route path="ols2900/2912" element={<OLS2912 />} />
        <Route path="ols2900/2913" element={<OLS2913 />} />
        <Route path="ols2900/2914" element={<OLS2914 />} />
        <Route path="ols2900/2915" element={<OLS2915 />} />
        <Route path="ols2900/2916" element={<OLS2916 />} />
        <Route path="ols2900/2917" element={<OLS2917 />} />
        <Route path="ols2900/2918" element={<OLS2918 />} />
        <Route path="ols2900/2919" element={<OLS2919 />} />
        <Route path="ols2900/2920" element={<OLS2920 />} />
        <Route path="ols2900/2921" element={<OLS2921 />} />
        <Route path="ols2900/2922" element={<OLS2922 />} />
        <Route path="ols2900/2922.olslm" element={<OLSLM2922 />} />
        <Route path="ols2900/2923.olslm" element={<OLSLM2923 />} />
        <Route path="ols2900/2924.olslm" element={<OLSLM2924 />} />
        <Route path="ols2900/2945" element={<OLS2945 />} />
        <Route path="ols2900/2953" element={<OLS2953 />} />
        <Route path="ols2900/2965" element={<OLS2965 />} />
          <Route path="ols2900/2966" element={<OLS2966 />} />
        <Route path="ols2900/2967" element={<OLS2967 />} /> {/* Added route for OLS2967 */}
        <Route path="upcoming" element={<OLSupdatesUp />} />
      </Routes>
    </FullHeightLayout>
  );
};

export default OLSupdates;